import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Mission from './pages/Mission';
import Contact from './pages/Contact';
import Referal from './pages/Referal';
import './App.css';

function App() {
  return (
    <Router>
      <div className="slds-scope">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/referal" element={<Referal />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 